import TaskModal from './TaskModal';
import { statuses } from './filters';
import { useTasks } from './useTasks';
import { useActions } from '../../hooks';
import { formatDate } from '../../utilities';
import { useAppContext } from '../../shared';
import { Slug, Button } from '../../components';
import { deleteTask, updateTask } from '../../api';
import { Dropdown, Input, Table } from '../../components';
import { Form, FormItem, TopPanel } from '../../components';
import type { ItemType } from './useTasks';

const getColor = (status: string): SlugColorType => {
  switch (status) {
    case 'pending':
      return 'warning';
    case 'failed':
      return 'danger';
    case 'completed':
      return 'success';
    default:
      return 'main';
  }
};

const Tasks = () => {
  const { meta } = useAppContext();
  const {
    nodes,
    refresh,
    filters,
    setFilters,
    reloading,
    intializing: loading,
  } = useTasks();
  const {
    element,
    isOpened,
    updating,
    initialValues,
    handleClose,
    handleEdit,
    handleStartEdit,
    handleStartDelete,
  } = useActions<ItemType, ItemType, ItemType>({
    name: 'Task',
    onRefresh: refresh,

    onEdit: updateTask,
    onDelete: deleteTask,
  });

  return (
    <div className="flex flex-col gap-y-md w-full">
      {element}
      {isOpened && (
        <TaskModal
          loading={updating}
          initialValues={initialValues}
          onSumbit={handleEdit}
          onClose={handleClose}
        />
      )}
      <TopPanel>
        <Form<NonNullable<typeof filters>>
          initialValue={filters}
          onChange={setFilters}
        >
          <FormItem<NonNullable<typeof filters>> name="campaignId" label="">
            <Dropdown
              placeholder="Campaign"
              grow={false}
              options={[
                { value: '', label: 'All Campaigns' },
                ...meta.campaigns,
              ]}
            />
          </FormItem>
          <FormItem<NonNullable<typeof filters>> name="status" label="">
            <Dropdown
              placeholder="Status"
              grow={false}
              options={[{ value: '', label: 'All Statuses' }, ...statuses]}
            />
          </FormItem>
          <FormItem<NonNullable<typeof filters>> name="contactId" label="">
            <Input placeholder="Filter By Contact Email" />
          </FormItem>
        </Form>
        <Button icon="refresh" loading={reloading} onClick={refresh}>
          Refresh
        </Button>
      </TopPanel>
      <div className="flex-1 overflow-y-auto">
        <Table
          data={nodes}
          loading={loading}
          config={{
            columns: [
              {
                header: 'Id',
                getValue: ({ id }) => (
                  <Slug text={id.split('-')[0] || ''} tooltip={id} />
                ),
              },
              {
                header: 'Type',
                cellClassName: 'text-tiny',
                getValue: ({ task_type }) => task_type,
              },
              {
                header: 'Contact',
                cellClassName: 'text-small',
                getValue: ({ contact_id }) => contact_id,
              },
              {
                header: 'Status',
                getValue: ({ status }) => (
                  <Slug text={status} color={getColor(status)} />
                ),
              },
              {
                header: 'Scheduled At',
                cellClassName: 'text-tiny',
                getValue: ({ scheduled_at }) => formatDate(scheduled_at),
              },
              {
                header: 'Actions',
                align: 'right',
                getValue: item => (
                  <div className="flex flex-row gap-x-sm justify-end">
                    <Button
                      icon="edit"
                      type="primary"
                      onClick={() => handleStartEdit(item)}
                    />
                    <Button
                      icon="delete"
                      type="danger"
                      onClick={() => handleStartDelete(item)}
                    />
                  </div>
                ),
              },
            ],
          }}
        />
      </div>
    </div>
  );
};

export default Tasks;
